import { Link as MUILink, LinkProps as MUILinkProps } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

interface LinkProps extends Omit<MUILinkProps, "href"> {
  to: string;
}

const Link: React.FC<LinkProps> = ({ underline, to, ...innerProps }) => (
  <MUILink
    {...innerProps}
    underline={underline ?? "none"}
    to={to}
    component={RouterLink}
  />
);

export default Link;
